import Axios from "@/plugins/Axios";
import Aluno from "@/Models/Aluno";
import Matricula from "@/Models/Matricula";

const HEADERS_UPLOAD = { "Content-Type": "multipart/form-data" };

class AlunosService {
  async atualizarAluno(aluno) {
    const response = await Axios().put(`alunos/${encodeURIComponent(aluno.id)}`, aluno);

    return new Aluno(response.data);
  }

  async coresOuRacas(franquiaId = null) {
    return Axios().get("alunos/cores-ou-racas", {
      params: {
        franquia_id: franquiaId,
      },
    });
  }

  async cortarCarteiraVacina(tamanhos, name) {
    return this.cortarImagem("cortar-imagem-carteira-vacina", tamanhos, name);
  }

  async cortarImageAluno(tamanhos, name) {
    return this.cortarImagem("cortar-imagem-aluno", tamanhos, name);
  }

  async cortarImagem(url, tamanhos, name) {
    const response = await Axios().post(url, { coordinates: tamanhos, nameFile: name });

    return response.data;
  }

  async criarAluno(aluno) {
    const response = await Axios().post("alunos", aluno);

    return new Aluno(response.data);
  }

  async deficientes() {
    return Axios().get("alunos/deficientes");
  }

  async deletarAluno(aluno) {
    const response = await Axios().delete(`alunos/${encodeURIComponent(aluno.id)}`);

    return new Aluno(response.data);
  }

  async downloadLaudo(alunoId) {
    const response = await Axios().get(`alunos/download-laudo/${encodeURIComponent(alunoId)}`, {
      responseType: "blob",
    });

    window.open(window.URL.createObjectURL(response.data));
  }

  async faixaEtaria(franquiaId = null) {
    return Axios().get("alunos/faixa-etaria", {
      params: { franquia_id: franquiaId },
    });
  }

  async generos() {
    return Axios().get("alunos/generos");
  }

  async getAlunoComINEP(codigoInep) {
    const response = await Axios().get(`alunos/codigo-inep/${encodeURIComponent(codigoInep)}`);

    return response.data ? new Aluno(response.data) : null;
  }

  async matriculasAluno(form) {
    const response = await Axios().post("alunos/matriculas-aluno", form);

    return response.data.map((matricula) => new Matricula(matricula));
  }

  async matriculasAlunoNoAno(alunoId) {
    const response = await Axios().get(
      `alunos/quantidade-matriculas-aluno-ano/${encodeURIComponent(alunoId)}`
    );

    return response.data.qtdMatriculasAlunoAno;
  }

  async pegarAluno(id) {
    const response = await Axios().get(`alunos/${encodeURIComponent(id)}`);

    return new Aluno(response.data);
  }

  async pesquisaAvancada(pageNumber, query, form) {
    const response = await Axios().get("alunos/pesquisa-avancada", {
      params: {
        ...form,
        page: pageNumber,
        query,
      },
    });

    return response.data;
  }

  async recuperarAluno(aluno) {
    return this.atualizarAluno({ ...aluno, deleted_at: null });
  }

  async syncAll() {
    const response = await Axios().get("alunos");

    return response.data.map((aluno) => new Aluno(aluno));
  }

  async syncAllPaginate(pageNumber, query) {
    const response = await Axios().get("alunos/listAllPaginate", {
      params: {
        page: pageNumber,
        query,
      },
    });
    return response.data;
  }

  async uploadArquivo(url, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post(url, formData, {
      headers: HEADERS_UPLOAD,
    });

    return response.data;
  }

  async uploadCarteiraVacina(file) {
    return this.uploadArquivo("alunos/upload-carteira-vacinacao", file);
  }

  async uploadImageAluno(file) {
    return this.uploadArquivo("alunos/upload-imagem-do-aluno", file);
  }

  async uploadLaudo(laudoData, alunoId) {
    return Axios().post(`alunos/upload-laudo/${encodeURIComponent(alunoId)}`, laudoData, {
      headers: HEADERS_UPLOAD,
    });
  }

  async verificarCpfGlobal(cpf) {
    const response = await Axios().get(`alunos/verificar-cpf-global/${encodeURIComponent(cpf)}`);

    return response.data;
  }

  async zona() {
    return Axios().get("alunos/zona");
  }
}

export default new AlunosService();
